import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchBoxLite from '@homeaway/react-searchbox-lite';
import { FormattedMessage } from '../Intl';
import { messageKeys, getLabels } from './translations';

import './ReactSearchBox.less';

class SearchBox extends Component {
  componentDidMount() {
    window.ha.userTiming.mark('primary.action.rendered');
  }

  onSubmit = ({ searchPath }) => {
    window.location.href = searchPath;
  }

  render() {
    const {
      locale,
      site,
      destination,
      checkIn,
      checkOut,
      guests,
      lbsId,
      domain,
      isMobile
    } = this.props;

    return (
      <FormattedMessage id={messageKeys}>
        {(...messages) => (
          <SearchBoxLite
            brand={site === 'vrbo' ? 'vrbo' : 'homeaway'}
            consolidatedSearchBox
            datePickerIcon
            guestPickerIcon
            expandedSearchBox
            showNextTooltip
            consolidateInputs={isMobile}
            smartDatePicker={isMobile}
            submitFromGuestPicker={isMobile}
            isStickyMobile={isMobile}
            labels={getLabels(...messages)}
            geoType={'point_of_interest'}
            onSubmit={this.onSubmit}
            typeaheadProps={{
              hideSpinner: true,
              baseUrl: 'https://www.homeaway.com',
              environment: 'production',
              site
            }}
            {...{ domain, site, checkIn, checkOut, guests, lbsId, locale, destination }}
          />
        )}
      </FormattedMessage>
    );
  }
}

SearchBox.propTypes = {
  locale: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  guests: PropTypes.shape({}),
  lbsId: PropTypes.string,
  destination: PropTypes.string,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  isMobile: PropTypes.bool.isRequired
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/universal/components/ReactSearchBox/ReactSearchBox.js